import { render, staticRenderFns } from "./BusinessInfo.vue?vue&type=template&id=7506c1a6"
import script from "./BusinessInfo.vue?vue&type=script&lang=js"
export * from "./BusinessInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports